import React from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import PersonIcon from "@mui/icons-material/Person";
import { Link } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import Flip from "react-reveal/Flip";

function ExperienceJourney() {
  return (
    <div className="mt-5">
      <div>
        <Link className="btn btn-primary m-1" to="/educationjourney">
          Educational Journey
        </Link>
        <Link className="btn btn-primary m-1" to="/experiencejourney">
          Internships/Experience Journey
        </Link>
        <Link className="btn btn-primary m-1" to="/technicaljourney">
          Technical Journey
        </Link>
        <Link className="btn btn-primary m-1" to="/projectjourney">
          Project Journey
        </Link>
      </div>
      <div className="mt-5">
        <Flip top cascade>
          <h1>Experience Journey</h1>
        </Flip>
      </div>
      <VerticalTimeline>


<VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "rgb(78 22 112)", color: "#fbd9ad" }}
          contentArrowStyle={{ borderLeft: "7px solid  rgb(78 22 112)" }}
          date="Feb 2025 - Present"
          iconStyle={{ background: "rgb(78 22 112)", color: "#fbd9ad"}}
          icon={<PersonIcon />}
        >
          <h5 className="vertical-timeline-element-title">
            Appbleed
          </h5>
          <h6 className="vertical-timeline-element-subtitle mt-2">
            Software Developer
          </h6>
          <p>• Working on mozome.com and mozome apps</p>
          <p>• Tech Stack - ReactJs, Nodejs, Typescript, TailwindCss, Flutter, Dart, FullStack Development, App Development .</p>
        </VerticalTimelineElement>



        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "rgb(78 22 112)", color: "#fbd9ad" }}
          contentArrowStyle={{ borderLeft: "7px solid  rgb(78 22 112)" }}
          date="Jun 2024 - Sep 2024"
          iconStyle={{ background: "rgb(78 22 112)", color: "#fbd9ad" }}
          icon={<PersonIcon />}
        >
          <h5 className="vertical-timeline-element-title">
            Jalan Technologies
          </h5>
          <h6 className="vertical-timeline-element-subtitle mt-2">
            Associate Software Engineer
          </h6>
          <p>• Worked on Live Project.</p>
          <p>• Tech Stack - ReactJs, Nodejs, Typescript, TailwindCss.</p>
        </VerticalTimelineElement>
        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "rgb(78 22 112)", color: "#fbd9ad" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(78 22 112)" }}
          date="Feb 2024 - May 2024"
          iconStyle={{ background: "rgb(78 22 112)", color: "#fbd9ad" }}
          icon={<PersonIcon />}
        >
          <h5 className="vertical-timeline-element-title">Oyelabs</h5>
          <h6 className="vertical-timeline-element-subtitle mt-2">
            Software Engineer Intern
          </h6>
          <p>• Worked on Live Projects</p>
          <p>• Tech Stack - Reactjs, Nodejs, TailwindCss, Javascript.</p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          className="vertical-timeline-element--work"
          contentStyle={{ background: "rgb(78 22 112)", color: "#fbd9ad" }}
          contentArrowStyle={{ borderRight: "7px solid  rgb(78 22 112)" }}
          date="Feb 2024 - May 2024"
          iconStyle={{ background: "rgb(78 22 112)", color: "#fbd9ad" }}
          icon={<PersonIcon />}
        >
          <h5 className="vertical-timeline-element-title">SisTec</h5>
          <h6 className="vertical-timeline-element-subtitle mt-2">
            Web Development Trainee
          </h6>
          <p>• Learnt the basics of web-dev ie. https, server, dom, etc...</p>
          <p>• Tech Stack - Html, CSS, Javascript, PHP.</p>
        </VerticalTimelineElement>

        <VerticalTimelineElement
          iconStyle={{ background: "#fbd9ad", color: "rgb(78 22 112)" }}
          icon={<StarIcon />}
        />
      </VerticalTimeline>
    </div>
  );
}

export default ExperienceJourney;
